export default "__VITE_ASSET__BDO9LiRB__"